import React, { Suspense } from "react";

import { SpinnerFullScreen } from "../../components/SpinnerFullScreen";
import Search from "./Search";

// const Route = React.lazy(() => import("./Search"));

export const SearchRouteWithLazy: React.FC = () => {
  return (
    <Suspense fallback={<SpinnerFullScreen />}>
      <Search />
    </Suspense>
  );
};
